"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TRANSFORMS = Object.freeze({
    thumb_small: 'c_fill,f_auto,g_center,h_96,w_96',
    thumb_large: 'c_fill,f_auto,g_center,h_450,w_450',
    original: 'c_limit,f_auto,h_1200,w_1200',
});
function coreImageURLs(images, transform, coreImageCdn) {
    var transformString = TRANSFORMS[transform];
    var baseURL = coreImageCdn + "/image/upload/" + transformString;
    return images.map(function (_a) {
        var publicId = _a.publicId, version = _a.version;
        return baseURL + "/v" + version + "/" + publicId + ".jpg";
    });
}
exports.coreImageURLs = coreImageURLs;
function lPImageURLs(keys, transform, uploadImageCdn) {
    return keys.map(function (_a) {
        var key = _a.key;
        var transformString = TRANSFORMS[transform];
        return uploadImageCdn + "/image/upload/" + transformString + "/v1/v2/images/" + key;
    });
}
exports.lPImageURLs = lPImageURLs;
//# sourceMappingURL=image_urls.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/image_urls.js
// module id = 6Uak
// module chunks = 20 21 22